import React from "react";
import PropTypes from "prop-types";

const Highcharts = window.Highcharts;
const HighchartsReact = window.HighchartsReact;

import { chartOptions, odaTooltipOptions, COLUMN_COLOR } from "../chartOptions";

const mapValues = data => data.map(d => ({y: d.value, name: d.name}));

const mapXAxis = data => data.map(d => d.name);

const FinancingCharts = ({ overallOdaData }) => {
  const donorDisbursement = {
    title: {
      text: "Top 10 donors by disbursement, 1973-2022",
      style: {
        fontWeight: "bold",
        fontSize: "1.4rem"
      }
    },
    series: [
      {
        data: mapValues(overallOdaData.top_ten_donors),
        color: COLUMN_COLOR
      }
    ],
    ...chartOptions,
    tooltip: odaTooltipOptions,
    xAxis: {
      categories: mapXAxis(overallOdaData.top_ten_donors),
      tickLength: 0,
      labels: {
        formatter: function() {
          const donorsArr = this.value.split("-"); // remove Grants or Loans
          const agenciesArr = donorsArr[0].split(" ");
          const abbrevsArr = agenciesArr.map(w => w.charAt(0).toUpperCase());
          const abbrevs = abbrevsArr.join("");
          let label = "";
          switch (abbrevs) {
          case "FDA":
            label = "AFD";
            break;
          case "ADB":
            label = "AfDB";
            break;
          case "KFW":
            label = "KfW";
            break;
          case "USAFID":
            label = "USAID";
            break;
          case "MOFAJ":
            label = "Japan";
            break;
          case "FMFECADG":
            label = "Germany";
            break;
          case "DFIDU":
            label = "DFID";
            break;
          default:
            label = abbrevs;
          }
          return `<div title="${this.value}">${label}</div>`;
        },
        useHTML: true,
      }
    },
    yAxis: {
      title: {
        text: "$ billion"
      }
    },
  };

  const recipientCountries = {
    title: {
      text: "Top 10 countries by recipient, 1973-2022",
      style: {
        fontWeight: "bold",
        fontSize: "1.4rem"
      }
    },
    series: [
      {
        data: mapValues(overallOdaData.top_ten_countries),
        color: COLUMN_COLOR
      }
    ],
    ...chartOptions,
    tooltip: odaTooltipOptions,
    xAxis: {
      categories: mapXAxis(overallOdaData.top_ten_countries),
      tickLength: 0
    },
    yAxis: {
      title: {
        text: "$ billion"
      }
    },
  };

  return (
    <div>
      <div className="oda-chart-wrapper">
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={"chart"}
          options={donorDisbursement}
        />
      </div>
      <div className="oda-chart-wrapper">
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={"chart"}
          options={recipientCountries}
        />
      </div>
    </div>
  );
};

FinancingCharts.propTypes = {
  overallOdaData: PropTypes.shape({}).isRequired,
};

export default FinancingCharts;
